import { useRouter } from "next/router";
import useFunnelRouteDeclare from "@/hooks/useFunnelRouteDeclare";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";
import PromotionTutorialContainer from "@/containers/Promotion/PromotionTutorialContainer";
import { useCustomFeature } from "@/hooks/useCustomFeature";

const TUTORIAL_IMAGES = [
  "direct/promotion/26-f/step-tutorial-01.png",
  "direct/promotion/26-f/step-tutorial-02.png",
  "direct/promotion/26-f/step-tutorial-03.png",
  "direct/promotion/26-f/step-tutorial-04.png",
];

export default function Promotion26F() {
  const router = useRouter();
  const { paths } = useFunnelRouteDeclare({
    uniqueKey: landingFunnelKey.GROUP["promotion_26_f"],
  });
  const feature = useCustomFeature(26);

  return (
    <PromotionTutorialContainer
      images={TUTORIAL_IMAGES}
      onNextComplete={() => {
        router.push(paths.info);
      }}
      isNextCompleteDisabled={!feature}
    />
  );
}
